import { render } from "./PurchaseOrderList.vue?vue&type=template&id=6502e870&scoped=true"
import script from "./PurchaseOrderList.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderList.vue?vue&type=script&lang=js"

import "./PurchaseOrderList.vue?vue&type=style&index=0&id=6502e870&scoped=true&lang=css"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6502e870"]])

export default __exports__